<template>
  <ul class="h-selector">
    <li v-if="selectedItem" class="h-selector-item" v-for="(item, index) in items"
        :item="item"
        v-bind:key="item.value"
        :class="{ 'delimiter': index !== 0, 'selected': selectedItem.key === item.key }"
        @click="itemClicked(item)">
      <div class="theme-indicator">
        <div class="theme-indicator-circle" :class="item.indicatorClass">
        </div>
        <div class="theme-indicator-text">
          {{ item.value }}
        </div>
      </div>

    </li>
  </ul>
</template>

<script>

  export default {
    name: "themes-selector",
    props: {
      items: {
        type: Array,
        default: []
      },
      selectedItem: {
        type: Object,
      }
    },
    model: {
      prop: 'selectedItem',
    },
    data: function(){
      return {

      }
    },
    created() {

    },
    methods: {
      itemClicked(item) {
        this.$emit('input', item);
      },
    },
    computed: {

    }
  }

</script>

<style lang='scss' scoped>
  @import "../../../../assets/scss/_mixins";
  .h-selector {
    height: 82px;
    width: 100%;
    display: flex;
    @include themify {
      color: getColor('user-menu-text', 'framework');
    }

    .h-selector-item {
      ALIGN-ITEMS: center;
      JUSTIFY-CONTENT: center;
      position: relative;
      flex: 1;
      display: flex;
      .theme-indicator {
        background-size: 26px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .theme-indicator-text {
          line-height: 25px;
        }
        .theme-indicator-circle {
          height: 42px;
          width: 62px;
          &.theme-dark-indicator{
            @include lp-bg-image('assets/img/dark-theme-thumbnail.svg');
          }
          &.theme-light-indicator{
            @include lp-bg-image('assets/img/light-theme-thumbnail.svg');
          }
        }
      }

      &.selected {
        @include themify {
          background-color: getColor('user-menu-status-item-selected-bg', 'framework');
          border: 1px solid getColor('user-menu-theme-indicator-item-selected-border', 'framework');
        }
      }
    }
  }
</style>
